import {TRootState} from "types";

export const projectInsightSelectedFiltersSelector = (state: TRootState) =>
	state.mapxProject.insightsFilters;

export const projectInsightSelectedSenioritySelector = (state: TRootState) =>
	state.mapxProject.insightsFilters.current_seniority;

export const projectInsightSelectedJobFunctionsSelector = (state: TRootState) =>
	state.mapxProject.insightsFilters.current_specialisms;

export const projectInsightSelectedKeywordsSelector = (state: TRootState) =>
	state.mapxProject.insightsFilters.current_text_keywords_or;

export const projectInsightSelectedLocationsSelector = (state: TRootState) =>
	state.mapxProject.insightsFilters.countries;

export const projectInsightSelectedCompaniesSelector = (state: TRootState) =>
	state.mapxProject.insightsFilters.current_companies;

export const insightsFilterSelectedCompaniesSelector = (state: TRootState) =>
	state.mapxProject.insightsFilterSelectedCompanies;
